import { additionalPatchedTypeMatches, AvlIcon, patchedTypes } from '#avl/constants'
import { AvlPatch } from '#avl/model'
import { useAvlParser } from '#avl/parser'
import { usePhotgraphsAssetResolver } from '#photographs/assetresolver'
import { RecordPlugin, RecordPluginDescriptor, useDefaultRecordPlugin } from '#record/plugin'
import { useT } from 'apprise-frontend-core/intl/language'
import { useAvlColumns } from './columns'
import { AvlOverview } from './overview'
import { AvlPatchCard } from './patch'
import { transformAvlPatch } from './patchtransform'
import { useAvlValidation } from './validator'

export const useAvlPluginDescriptor = (): RecordPluginDescriptor => {

    const t = useT()

    const defaults = useDefaultRecordPlugin()

    return {

        ...defaults

        ,

        Icon: AvlIcon

        ,

        name: t('avl.type')

        ,

        submission_type: t('avl.sub_type')

        ,

        singular: t('avl.singular')

        ,

        plural: t('avl.plural')

        ,

        patchedTypes

        ,

        additionalPatchedTypeMatches

        ,

        useAssets: true


    }

}


export const useAvlPlugin = () => {


    const self: RecordPlugin<AvlPatch> = {


        ...useDefaultRecordPlugin()

        ,

        ...useAvlPluginDescriptor()

        ,


        parse: useAvlParser

        ,

        patchTransform: transformAvlPatch

        ,

        currentColumns: () => []

        ,

        patchColumns: useAvlColumns

        ,

        validate: useAvlValidation

        ,

        Patch: AvlPatchCard

        ,

        resolveAssets: usePhotgraphsAssetResolver(transformAvlPatch)

        ,

        Overview: AvlOverview

        ,

        allowedScopes: ['rav', 'external']

        ,

        allowThirdPartyFor: record => [record.scope === 'external', 'warning']

        ,


        canClaim: record => record.current?.scope === 'external'


        // excelserialize: useAuthorizationExcelSerializer

        // ,

        // excelwrite: useAuthorizationExcelWriter

        // ,

        // Form: AuthorizationForm

        // ,

        // formFields: useAuthorizationFormFields



        // ,

        // newSlot: newAuthorizationSlot

    }

    return self
}
